import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import FilterService from "../../services/FilterService";
import { toast } from "react-toastify";
import "./AddFilter.css";

const AddFilterModal = ({ showModal, handleClose, onFilterAdded }) => {
  const [formData, setFormData] = useState({
    name: "",
    type: "",
    lastingDuration: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const saveFilter = async () => {
    try {
      const payload = {
        filter_name: formData.name, // Ensure field matches backend
        filter_code: formData.type, // Ensure field matches backend
        lasting_duration: parseInt(formData.lastingDuration), // Backend may expect an integer
      };
  
      console.log("Payload sent to server:", payload); // Debug payload
  
      const response = await FilterService.create(payload);
      toast.success(response?.data?.message || "Filter added successfully", {
        autoClose: 2000,
      });
  
      // Refresh the filters list
      onFilterAdded();
      handleClose();
      setFormData({ name: "", type: "", lastingDuration: "" }); // Reset form
    } catch (error) {
      console.error("Failed to add filter:", error);
      const errorMessage = error.response?.data?.message || "Failed to add filter";
      toast.error(errorMessage);
    }
  };
  

  return (
    <Modal className="add-filter-modal" show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title className="title">Add New Filter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="form-group">
            <label>Filter Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Filter Name"
              required
            />
          </div>
          <div className="form-group">
            <label>Type</label>
            <input
              type="text"
              name="type"
              value={formData.type}
              onChange={handleInputChange}
              placeholder="Type"
              required
            />
          </div>
          <div className="form-group">
            <label>Lasting Duration (Months)</label>
            <input
              type="number"
              name="lastingDuration"
              value={formData.lastingDuration}
              onChange={handleInputChange}
              placeholder="Duration in Months"
              required
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end w-100">
          <Button variant="primary" onClick={saveFilter} className="w-100">
            Save
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddFilterModal;
